import { State } from 'common/store/reducers';

export const selectQuickStartType = (state: State) => state.quickStart.quickStart.type;
export const selectQuickStartUserId = (state: State) => state.quickStart.quickStart.userId;
